import type { ReactNode } from 'react';
import { Notification } from '@nespresso-design-system/components';
import FormattedText from '@nespresso/catalog-components-react/containers/FormattedText';
import type { Product } from '@/domain/Product';
import useTranslations from '@/widgets/hooks/useTranslations.tsx';
import styles from './ProductCompatibilitySection.module.scss';

export type ProductCompatibilitySectionProps = {
  product: Product;
};

export default function ProductCompatibilitySection({
  product: { technologies, type }
}: ProductCompatibilitySectionProps) {
  const { t } = useTranslations();
  const isVertuo = technologies.includes('vertuo');
  const isOriginal = technologies.includes('original');
  const hasCompatibilityNotification = type === 'machine';

  let compatibilityText = '';
  if (isOriginal) {
    compatibilityText = t(
      'productDetailsHero.productCompatibilitySection.onlyOriginal'
    );
  }
  if (isVertuo) {
    compatibilityText = t(
      'productDetailsHero.productCompatibilitySection.onlyVertuo'
    );
  }

  if (!compatibilityText) {
    return null;
  }

  if (!hasCompatibilityNotification) {
    return null; // @todo - support for coffee/accessory compatibility?
  }

  return (
    <section class={styles.container}>
      <Notification hasDismissButton={false}>
        {
          (
            <FormattedText as="span">{compatibilityText}</FormattedText>
          ) as ReactNode
        }
      </Notification>
    </section>
  );
}

ProductCompatibilitySection.Skeleton = function Skeleton() {
  return null;
};
